import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { EASE } from "./Reveal";

// Scroll-triggered masked line reveal. The untransformed wrapper is observed
// (reliable), the inner span carries the percentage mask animation.
export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <span ref={ref} className={`block overflow-hidden pb-[0.1em] -mb-[0.1em] ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={inView ? { y: "0%" } : {}}
        transition={{ duration: 0.85, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};
